import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthGuard } from 'app/auth/helpers/auth.guards';
import { LoaderRoutingModule } from 'app/shared/utility/utility-routing.module';
import { BranchNetworkService } from './services/branch-network.service';
import { BranchNetworkComponent } from './view/branch-network.component';

const routes = [
  {
    path: 'branch-network',
    component: BranchNetworkComponent,
    data: { animation: 'BranchNetworkComponent' },
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [
    BranchNetworkComponent
  ],
  imports: [RouterModule.forChild(routes),
    CoreCommonModule,
    CardSnippetModule,
    CoreDirectivesModule,
    LoaderRoutingModule,
    NgSelectModule,
    NgbModule,
  ],
  exports: [],
  providers: [
    BranchNetworkService
  ]
})
export class BranchNetworkRoutingModule { }
